import { call, put, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import { authService } from '../../services/authService'
import {
  AuthActionTypes,
  LoginCredentials,
  SignupData,
  signupSuccess,
  signupFailure,
  verifyEmailSuccess,
  verifyEmailFailure,
  loginSuccess,
  loginFailure,
  checkAuthSuccess,
  checkAuthFailure,
  logoutSuccess,
  logoutFailure,
} from '../actions/authActions'

// Signup saga
function* signupSaga(action: PayloadAction<SignupData>): Generator<any, void, any> {
  try {
    yield call(authService.signup, action.payload)
    yield put(signupSuccess())
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'Signup failed'
    yield put(signupFailure(errorMessage))
  }
}

// Verify email saga
function* verifyEmailSaga(action: PayloadAction<string>): Generator<any, void, any> {
  try {
    const response: any = yield call(authService.verifyEmail, action.payload)
    yield put(verifyEmailSuccess(response.data.user, response.data.token))
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'Email verification failed'
    yield put(verifyEmailFailure(errorMessage))
  }
}

// Login saga
function* loginSaga(action: PayloadAction<LoginCredentials>): Generator<any, void, any> {
  try {
    const response: any = yield call(authService.login, action.payload)
    localStorage.setItem('token', response.data.token)
    localStorage.setItem('authProvider', response.data.user?.authProvider || 'email')
    yield put(loginSuccess(response.data.user, response.data.token))
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'Login failed'
    yield put(loginFailure(errorMessage))
  }
}

// Check auth saga
function* checkAuthSaga(): Generator<any, void, any> {
  try {
    const token = localStorage.getItem('token')
    if (!token) {
      throw new Error('No token found')
    }

    const response: any = yield call(authService.verifyToken)
    yield put(checkAuthSuccess(response.data.user))
  } catch (error: any) {
    localStorage.removeItem('token')
    localStorage.removeItem('authProvider')
    const errorMessage = error.response?.data?.error?.message || 'Authentication failed'
    yield put(checkAuthFailure(errorMessage))
  }
}

// Logout saga
function* logoutSaga() {
  try {
    yield call(authService.logout)
    localStorage.removeItem('token')
    localStorage.removeItem('authProvider')
    yield put(logoutSuccess())
  } catch (error: any) {
    localStorage.removeItem('token')
    localStorage.removeItem('authProvider')
    const errorMessage = error.response?.data?.error?.message || 'Logout failed'
    yield put(logoutFailure(errorMessage))
  }
}

// Watcher sagas
export function* watchAuthSagas() {
  yield takeLatest(AuthActionTypes.SIGNUP_REQUEST, signupSaga)
  yield takeLatest(AuthActionTypes.VERIFY_EMAIL_REQUEST, verifyEmailSaga)
  yield takeLatest(AuthActionTypes.LOGIN_REQUEST, loginSaga)
  yield takeLatest(AuthActionTypes.CHECK_AUTH_REQUEST, checkAuthSaga)
  yield takeLatest(AuthActionTypes.LOGOUT_REQUEST, logoutSaga)
}